import { useState } from 'react';


const IPAddressGenerator = () => {
  const [ipAddress, setIpAddress] = useState('');
  const [ipVersion, setIpVersion] = useState('IPv4');

  const generateIpAddress = () => {
    if (ipVersion === 'IPv4') {
      const randomIp = Array.from({ length: 4 }, () => Math.floor(Math.random() * 256)).join('.');
      setIpAddress(randomIp);
    } else {
      const randomIp = Array.from({ length: 8 }, () => Math.floor(Math.random() * 65536).toString(16)).join(':');
      setIpAddress(randomIp);
    }
  };

  const copyIpAddress = () => {
    navigator.clipboard.writeText(ipAddress);
  };


  const handleClear = () => {
    setIpAddress('');
    setIpVersion('');
  };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(ipAddress);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
    <div className="card-body">
      <div className="d-flex justify-content-center mb-4">
        <button
          className={`btn ${ipVersion === 'IPv4' ? 'btn-primary' : 'btn-light'} me-2`}
          onClick={() => setIpVersion('IPv4')}
        >
          IPv4
        </button>
        <button
          className={`btn ${ipVersion === 'IPv6' ? 'btn-primary' : 'btn-light'}`}
          onClick={() => setIpVersion('IPv6')}
        >
          IPv6
        </button>
      </div>
      <div className="d-flex justify-content-center mb-4">
        <button
          className="btn btn-primary"
          onClick={generateIpAddress}
        >
          Generate IP Address

        </button>
      </div>
      <div className="d-flex justify-content-center mb-4">
        <input
          type="text"
          value={ipAddress}
          className="form-control w-75 me-2"
          readOnly
        />
        <button
          className="btn btn-primary"
          onClick={copyIpAddress}
        >
           Copy
        </button>
        <button
        className="btn btn-danger "
        onClick={handleClear}
      >
     Clear
      </button>
      </div>
    </div>
    <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
 
</div>

  );
};

export default IPAddressGenerator;